import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Box,
  Button,
  Container,
  FormLabel,
  FormControl,
  Typography,
  Link,
} from "@material-ui/core";
import Page from "src/components/Page";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import { apiEndpoints, apiGetRequest } from "src/utils/api/api";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "./KmCalendar.css";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useMountedState } from "react-use";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  massagebox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  title: {
    marginLeft: theme.spacing(3.5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    flexGrow: 1,
  },
}));

const messages = {
  allDay: "Cały dzień",
  previous: "<",
  next: ">",
  today: "Dzisiaj",
  month: "Miesiąc",
  week: "Tydzień",
  day: "Dzień",
  agenda: "Agenda",
  date: "Data",
  time: "Czas",
  event: "Zdarzenie",
  showMore: (total) => `+ Kolejne (${total})`,
};

const localizer = momentLocalizer(moment);

const CalendarView = ({
  globalData,
  enableGlobalLoader,
  disableGlobalLoader,
}) => {
  const classes = useStyles();

  const [rows, setRows] = useState([]);
  const [dialogOpen, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [defaultView, setDefaultView] = React.useState({
    view: "month",
    date: new Date(),
  });
  const [calendarParentClass, setCalendarParentClass] = useState(null);

  const isMounted = useMountedState();

  useEffect(() => {
    if (isMounted) {
      enableGlobalLoader();
      apiGetRequest(apiEndpoints.getCalendarEvents.path, true)
        .then((data) => {
          disableGlobalLoader();
          setRows(
            data.map((event) => {
              return {
                title:
                  event?.name?.length > 20
                    ? event.name.substring(0, 20) + "..."
                    : event.name,
                start: moment(event.startsAt, "YYYY-MM-DD HH:mm:ss").toDate(),
                end: moment(event.endsAt, "YYYY-MM-DD HH:mm:ss").toDate(),
                name: event.name,
                startsAt: event.startsAt,
                endsAt: event.endsAt,
                url: event.url,
                urlLabel: event.urlLabel,
              };
            })
          );
        })
        .catch((error) => {
          disableGlobalLoader();
        });
    }
    return () => {};
  }, []);

  useEffect(() => {
    if (
      localStorage.getItem("wcagcontr") === "1" ||
      localStorage.getItem("wcagfont") === "1"
    ) {
      if (
        localStorage.getItem("wcagcontr") === "1" &&
        localStorage.getItem("wcagfont") === "1"
      ) {
        setCalendarParentClass("hicontrast largefont");
      } else if (localStorage.getItem("wcagcontr") === "1") {
        setCalendarParentClass("hicontrast");
      } else if (localStorage.getItem("wcagfont") === "1") {
        setCalendarParentClass("largefont");
      } else {
        setCalendarParentClass("");
      }
    } else {
      setCalendarParentClass("");
    }
    return () => {};
  }, [globalData.wcagflags]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const showEventDetails = (event) => {
    setSelectedEvent(event);
    handleClickOpen();
  };

  return (
    <Page className={classes.root} title="Kalendarz">
      <Container maxWidth={false}>
        <Box p={1}>
          <div
            className={calendarParentClass ? calendarParentClass : ""}
            style={{ height: "80vh" }}
          >
            <Calendar
              messages={messages}
              localizer={localizer}
              events={rows}
              defaultView={defaultView.view}
              culture="pl"
              views={["month", "day"]}
              onSelectEvent={(event) => showEventDetails(event)}
              onNavigate={(date) => setDefaultView({ view: "day", date: date })}
            />
            <Dialog
              fullScreen={fullScreen}
              fullWidth={fullWidth}
              open={dialogOpen}
              onClose={handleClose}
              aria-labelledby="responsive-dialog-title"
            >
              <DialogTitle id="responsive-dialog-title">
                {"Szczegóły wydarzenia"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <FormLabel>Nazwa</FormLabel>
                  <Typography variant="subtitle2" paragraph>
                    {selectedEvent ? selectedEvent.name : "-"}
                  </Typography>
                  <FormLabel>Data rozpoczęcia</FormLabel>
                  <Typography variant="subtitle2" paragraph>
                    {selectedEvent ? selectedEvent.startsAt : "-"}
                  </Typography>
                  <FormLabel>Data zakończenia</FormLabel>
                  <Typography variant="subtitle2" paragraph>
                    {selectedEvent ? selectedEvent.endsAt : "-"}
                  </Typography>
                  {selectedEvent && selectedEvent.url ? (
                    <>
                      <FormLabel>Odnośnik</FormLabel>
                      <Box display="block">
                        {selectedEvent.urlLabel ? (
                          <Link
                            target="_blank"
                            href={selectedEvent.url}
                            variant="body1"
                          >
                            {selectedEvent.urlLabel}
                          </Link>
                        ) : (
                          <Link
                            target="_blank"
                            href={selectedEvent.url}
                            variant="body1"
                          >
                            {selectedEvent.url}
                          </Link>
                        )}
                      </Box>
                    </>
                  ) : (
                    <></>
                  )}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button autoFocus onClick={handleClose} color="primary">
                  Zamknij
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </Box>
      </Container>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  globalData: state.globalData,
});

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CalendarView);
